var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinglesGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15V14C1 11.7909 2.79086 10 5 10H9C11.2091 10 13 11.7909 13 14V15",
    stroke: "#5D6577",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C5.3431 7 4 5.65685 4 4C4 2.34315 5.3431 1 7 1C8.6569 1 10 2.34315 10 4C10 5.65685 8.6569 7 7 7Z",
    stroke: "#5D6577",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglesGray);
export default __webpack_public_path__ + "static/media/singlesGray.8cd5b57f254504cd1b26ccd5e9870f13.svg";
export { ForwardRef as ReactComponent };